import Service from '../abstract/service'

export default class LinkForm extends Service {
  constructor() {
    super()
    this._api = "https://us-central1-flyvendas-1540928962729.cloudfunctions.net/app/api/links"
  }

  async create(cpf) {
    try {
      this._loading.setLoading(true, "Verificando Links")
      const response = await fetch(this._api, {
        method: "POST",
        mode: "cors",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          donoLead: cpf,
          empresaPrincipal: this._empresaPrincipal,
          grupoPrincipal: this._grupoPrincipal
        })
      })
      const content = await response.json()
      return Promise.resolve(content)
    } catch (error) {
      console.log(error);
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
}
